module.exports = __webpack_public_path__ + "img/volunteer_essentials_pathway.d63e37eb.png";